import RatingStarsInput from '@/classes/RatingStarsInput';

document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.rating-stars-input')
        .forEach((item) => new RatingStarsInput(item));
});
